// A week's plan is locked on the Friday before it runs, so changes take effect at a Monday beyond
// the locked window. Derived from the calendar until weekly plan snapshots are populated.
import { addWeeks, getDay, startOfWeek } from "date-fns"

/** Earliest safe Monday (a default, not the only allowed one): next week, or the one after from Friday on. */
export function firstEditableMonday(today: Date): Date {
  const thisMonday = startOfWeek(today, { weekStartsOn: 1 })
  const day = getDay(today) // 0 = Sunday, 5 = Friday, 6 = Saturday
  const lockedWeeksAhead = day === 5 || day === 6 || day === 0 ? 2 : 1
  return addWeeks(thisMonday, lockedWeeksAhead)
}

export function isMonday(date: Date): boolean {
  return getDay(date) === 1
}

export function isSelectableBoundary(date: Date, today: Date): boolean {
  if (!isMonday(date)) return false
  return date.getTime() >= firstEditableMonday(today).getTime()
}
